var _rect, _polyline, _polyline2, _circle, _text, _line, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _path2, _rect8, _rect9, _line2, _circle2, _circle3, _circle4, _circle5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactHero(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 55,
    width: 160,
    height: 105,
    rx: 7,
    fill: "rgba(255,255,255,0.12)",
    stroke: "rgba(255,255,255,0.75)",
    strokeWidth: 2
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "55,55 135,108 215,55",
    stroke: "rgba(255,255,255,0.75)",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "55,160 100,125 135,108 170,125 215,160",
    stroke: "rgba(255,255,255,0.4)",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 28,
    r: 16,
    fill: "rgba(255,255,255,0.1)",
    stroke: "rgba(255,255,255,0.6)",
    strokeWidth: 1.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 33,
    textAnchor: "middle",
    fontFamily: "system-ui,sans-serif",
    fontSize: 16,
    fill: "rgba(255,255,255,0.85)",
    fontWeight: 400
  }, "@")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 135,
    y1: 44,
    x2: 135,
    y2: 55,
    stroke: "rgba(255,255,255,0.35)",
    strokeWidth: 1.5,
    strokeDasharray: "4 3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 45,
    width: 75,
    height: 60,
    rx: 10,
    fill: "rgba(255,255,255,0.14)",
    stroke: "rgba(255,255,255,0.65)",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240,105 L230,120 L255,105 Z",
    fill: "rgba(255,255,255,0.14)",
    stroke: "rgba(255,255,255,0.65)",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 57,
    width: 54,
    height: 5,
    rx: 2.5,
    fill: "rgba(255,255,255,0.55)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 67,
    width: 44,
    height: 4,
    rx: 2,
    fill: "rgba(255,255,255,0.35)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 76,
    width: 50,
    height: 4,
    rx: 2,
    fill: "rgba(255,255,255,0.35)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 85,
    width: 34,
    height: 4,
    rx: 2,
    fill: "rgba(255,255,255,0.35)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 80,
    width: 55,
    height: 38,
    rx: 8,
    fill: "rgba(255,255,255,0.1)",
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68,92 L80,99 L68,108 Z",
    fill: "rgba(255,255,255,0.1)",
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 89,
    width: 38,
    height: 4,
    rx: 2,
    fill: "rgba(255,255,255,0.5)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 98,
    width: 28,
    height: 4,
    rx: 2,
    fill: "rgba(255,255,255,0.3)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 99,
    x2: 105,
    y2: 99,
    stroke: "rgba(255,255,255,0.3)",
    strokeWidth: 1,
    strokeDasharray: "3 4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 48,
    r: 3,
    fill: "rgba(255,255,255,0.5)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 228,
    cy: 42,
    r: 2.5,
    fill: "rgba(255,255,255,0.45)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 165,
    r: 2,
    fill: "rgba(255,255,255,0.35)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 162,
    r: 2,
    fill: "rgba(255,255,255,0.35)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactHero);
export default __webpack_public_path__ + "static/media/contact_hero.873b621d09c99dc43936b173a206e2e1.svg";
export { ForwardRef as ReactComponent };